import React from 'react'
import Button from 'component/Button'
import ProductFeaturesList from './ProductFeaturesList'

import './productFeatures.scss'

const ProductFeatures = ({ id, list, buttons }) => {
	return (
		<div className={`productFeatures ${id}`} key={id}>
			<ProductFeaturesList list={list} id={id} />
			<div className="productFeatures_buttonsWrapper">
				{buttons.map((btn) => (
					<Button
						link={btn.link}
						key={btn.id}
						title={btn.text}
						className={`btn-${btn.id}`}
					/>
				))}
			</div>
		</div>
	)
}

export default ProductFeatures
